exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-menu {\n  color: #FFFFFF;\n  margin-top: 10px;\n  padding-left: 25px;\n  height: 36px;\n  line-height: 36px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.scss
// module id = ../../../../../src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.scss
// module chunks = 14